<template>
  <div class="grid grid-cols-12 h-full">
    <div
      class="categories h-full col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2 border-r"
    >
      <ul class="p-4 font-light">
        <li class="p-2 text-xs text-gray-400">{{ title }}</li>

        <li>
          <ul>
            <li
              v-for="(nl, index) in sidebarLinks"
              :key="nl.title"
              :class="{ 'mb-2': index !== sidebarLinks.length - 1 }"
            >
              <router-link
                class="flex text-gray-700 items-center px-2.5 py-1 text-sm rounded border border-solid border-transparent hover:bg-white hover:border-gray-200"
                :to="nl.to"
                :class="setClass(nl.to)"
              >
                <component
                  :is="dynamicComponent(nl.iconName)"
                  class="mr-2.5 text-gray-800 svg_icon"
                  style="
                    height: 18px;
                    width: 18px;
                    fill: rgba(95, 147, 250, 0.1);
                  "
                />
                {{ nl.title }}
              </router-link>
            </li>
          </ul>
        </li>

        <li
          class="p-0 m-0"
          v-if="visibleChildren && visibleChildren.length > 0"
        >
          <ul class="children">
            <li v-for="(child, index) in visibleChildren" :key="index">
              <router-link :to="{ name: child.name }">
                {{ child.title }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div
      class="col-span-6 md:col-span-8 lg:col-span-9 xl:col-span-10 h-full overflow-hidden"
    >
      <router-view class="h-full overflow-hidden" />
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
  name: "index",
  props: {
    sidebarLinks: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    currentLocation() {
      return this.$route;
    },
    visibleChildren() {
      const currentRoute = this.$route;
      const matchedRoute = currentRoute.matched.find(
        (r) => r && r.meta && r.meta.showChildren
      );

      return (
        (matchedRoute &&
          matchedRoute.children.length > 0 &&
          matchedRoute.children) ||
        []
      );
    },
  },
  methods: {
    setClass(to) {
      const resolved = this.$router.resolve(to);
      if (this.currentLocation.path.includes(resolved.path)) {
        return "router-link-active";
      }
    },
    dynamicComponent(name) {
      return defineAsyncComponent(() => import(`@/icons/${name}.vue`));
    },
  },
};
</script>

<style lang="scss">
.categories {
  background-color: #fafafa;
  @apply h-full;
  li a.router-link-active,
  li a.router-link-exact-path-active,
  li a.router-link-exact-active {
    @apply text-blue-500 border-gray-200;
    background-color: white;
    font-weight: normal;
    .svg_icon {
      @apply text-blue-500;
      fill: #f1f6ff;
    }
  }
  .children {
    @apply p-0 m-0 pl-2.5 pt-3 border-0 border-l border-solid border-gray-300;
    margin-left: 20px;
    li {
      @apply relative;
      a {
        font-size: 13px;
        height: 32px;
        line-height: 28px;
        @apply border-0 ml-2.5;
        &.router-link-active {
          @apply bg-transparent text-blue-500;
        }
        &:hover {
          @apply bg-transparent text-blue-500;
        }
      }
      &:before {
        content: "";
        display: block;
        height: 1px;
        width: 13px;
        top: 13px;
        left: -11px;
        @apply absolute bg-gray-300;
      }
      &:last-child {
        &:after {
          content: "";
          display: block;
          height: 13px;
          width: 1px;
          background-color: #fafafa;
          top: 14px;
          left: -11px;
          @apply absolute;
        }
      }
    }
  }
}
</style>
